import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent, TextField, Button, Grid, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import axiosInstance from '../../utils/axiosConfig';

const PhoneNumber = () => {
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState(null);
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [twilioSid, setTwilioSid] = useState('');
  const [twilioAuthToken, setTwilioAuthToken] = useState('');

  // Fetch phone numbers when the component mounts
  useEffect(() => {
    fetchPhoneNumbers();
  }, []);

  const fetchPhoneNumbers = async () => {
    try {
      const response = await axiosInstance.get('/phoneNumbers');
      setPhoneNumbers(response.data);
    } catch (error) {
      console.error('Error fetching phone numbers', error);
    }
  };

  const handleCreatePhoneNumber = async () => {
    try {
      const newPhoneNumber = {
        name: name,
        phoneNumber: phoneNumber,
        twilioSid: twilioSid,
        twilioAuthToken: twilioAuthToken,
      };
      const response = await axiosInstance.post('/phoneNumbers', newPhoneNumber);
      setPhoneNumbers([...phoneNumbers, response.data]);
      clearForm();
    } catch (error) {
      console.error('Error creating phone number', error);
    }
  };

  const handleSelectPhoneNumber = (phone) => {
    setSelectedPhoneNumber(phone);
    setName(phone.name);
    setPhoneNumber(phone.phoneNumber);
    setTwilioSid(phone.twilioSid);
    setTwilioAuthToken(phone.twilioAuthToken);
  };

  const handleUpdatePhoneNumber = async () => {
    try {
      const updatedPhoneNumber = {
        name: name,
        phoneNumber: phoneNumber,
        twilioSid: twilioSid,
        twilioAuthToken: twilioAuthToken,
      };
      const response = await axiosInstance.put(`/phoneNumbers/${selectedPhoneNumber._id}`, updatedPhoneNumber);
      setPhoneNumbers(phoneNumbers.map(phone => phone._id === selectedPhoneNumber._id ? response.data : phone));
      clearForm();
    } catch (error) {
      console.error('Error updating phone number', error);
    }
  };

  const handleDeletePhoneNumber = async (id) => {
    try {
      await axiosInstance.delete(`/phoneNumbers/${id}`);
      setPhoneNumbers(phoneNumbers.filter(phone => phone._id !== id));
    } catch (error) {
      console.error('Error deleting phone number', error);
    }
  };

  const clearForm = () => {
    setSelectedPhoneNumber(null);
    setName('');
    setPhoneNumber('');
    setTwilioSid('');
    setTwilioAuthToken('');
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Phone Numbers
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card sx={{ maxWidth: 600 }}>
            <CardContent>
              <Typography variant="h5" component="div">
                Phone Number List
              </Typography>
              {phoneNumbers.map(phone => (
                <Box key={phone._id} sx={{ marginBottom: 2 }}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => handleSelectPhoneNumber(phone)}
                  >
                    {phone.name} - {phone.phoneNumber}
                  </Button>
                  <IconButton onClick={() => handleDeletePhoneNumber(phone._id)} color="error">
                    <DeleteIcon />
                  </IconButton>
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ maxWidth: 600 }}>
            <CardContent>
              <Typography variant="h5" component="div">
                {selectedPhoneNumber ? 'Edit Phone Number' : 'Create Phone Number'}
              </Typography>
              <TextField
                label="Name"
                fullWidth
                margin="normal"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <TextField
                label="Phone Number"
                fullWidth
                margin="normal"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
              <TextField
                label="Twilio SID"
                fullWidth
                margin="normal"
                value={twilioSid}
                onChange={(e) => setTwilioSid(e.target.value)}
              />
              <TextField
                label="Twilio Auth Token"
                fullWidth
                margin="normal"
                value={twilioAuthToken}
                onChange={(e) => setTwilioAuthToken(e.target.value)}
              />
              <Button variant="contained" color="primary" onClick={selectedPhoneNumber ? handleUpdatePhoneNumber : handleCreatePhoneNumber}>
                {selectedPhoneNumber ? 'Update Phone Number' : 'Create Phone Number'}
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PhoneNumber;
